import * as Actions from '../../actions';

const initialState = { data: null };

const listSubHaulingReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_SUB_HAULING_COMPANIES_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listSubHaulingReducer;
